import {
    CREATE_PROPERTY_MASTER_FAILURE,
    CREATE_PROPERTY_MASTER_REQUEST,
    CREATE_PROPERTY_MASTER_SUCCESS,
    DELETE_PROPERTY_MASTER_FAILURE,
    DELETE_PROPERTY_MASTER_REQUEST,
    DELETE_PROPERTY_MASTER_SUCCESS,
    FETCH_IPADDRESS_FAILURE,
    FETCH_IPADDRESS_REQUEST,
    FETCH_IPADDRESS_SUCCESS,
    FETCH_PROPERTY_MASTER_FAILURE,
    FETCH_PROPERTY_MASTER_REQUEST,
    FETCH_PROPERTY_MASTER_SUCCESS,
    FETCH_SINGLE_PROPERTY_MASTER_FAILURE,
    FETCH_SINGLE_PROPERTY_MASTER_REQUEST,
    FETCH_SINGLE_PROPERTY_MASTER_SUCCESS,
    UPDATE_PROPERTY_MASTER_FAILURE,
    UPDATE_PROPERTY_MASTER_REQUEST,
    UPDATE_PROPERTY_MASTER_SUCCESS,
    CREATE_USER_FORM_PROPERTY_MASTER,
    PROPERTY_MASTER_USERFORM_RESET
} from './propertyMaster.actionsType';

export const PROPERTY_MASTER = 'propertyMaster';

let initialState = {
    loading: false,
    propertyMaster: [],
    userform: {},
    ipAddressInfo: null,
    selectedProperty: {},
    errorMessage: '',
    iperrorMessage: ''
};

export let propertyMasterReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_PROPERTY_MASTER_REQUEST:
        case CREATE_PROPERTY_MASTER_REQUEST:
        case UPDATE_PROPERTY_MASTER_REQUEST:
        case FETCH_SINGLE_PROPERTY_MASTER_REQUEST:
        case DELETE_PROPERTY_MASTER_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_IPADDRESS_REQUEST:
            return {
                ...state
            };
        case FETCH_PROPERTY_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                propertyMaster: updatePayload
            };
        case FETCH_IPADDRESS_SUCCESS:
            return {
                ...state,
                ipAddressInfo: payload
            };
        case CREATE_PROPERTY_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {}
            };
        case UPDATE_PROPERTY_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {}
            };
        case FETCH_SINGLE_PROPERTY_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedProperty: updatePayload,
                userform: {
                    slno: updatePayload.fldSlNo,
                    description: updatePayload.fldDescription,
                    sdescription: updatePayload.fldShortName
                }
            };
        case DELETE_PROPERTY_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {},
                selectedProperty: {}
            };
        case FETCH_IPADDRESS_FAILURE:
            return {
                ...state,
                iperrorMessage: payload
            };
        case FETCH_PROPERTY_MASTER_FAILURE:
        case CREATE_PROPERTY_MASTER_FAILURE:
        case UPDATE_PROPERTY_MASTER_FAILURE:
        case FETCH_SINGLE_PROPERTY_MASTER_FAILURE:
        case DELETE_PROPERTY_MASTER_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_PROPERTY_MASTER:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case PROPERTY_MASTER_USERFORM_RESET:
            return {
                ...state,
                userform: {}
            };
        default:
            return state;
    }
};
